import React from 'react';

import Input from '../../../components/Input';

function TextFilter({filter, onChange}) {
  return (
    <Input
      type="text"
      value={filter.values[0] || ''}
      onChange={e => onChange({...filter, values: [e.target.value]})}
    />
  );
}

TextFilter.validate = filter => [];

TextFilter.operators = [
  'EQUAL',
  'NOT_EQUAL',
  'CONTAIN',
  'NOT_CONTAIN'
];

export default TextFilter;